import { Button, Flexer, Footer, Input, InputControl, InputPrefix, Label, Stack, useInput } from '@fold-dev/core'
import { useState } from 'react'
import { ColorButton } from '../../components'
import { COLORS } from '../../constants'
import { useAppStore } from '../../store/app'

export const CreateProject = ({ onBack, onCreate }) => {
    const name = useInput('')
    const [color, setColor] = useState('')
    const workspace = useAppStore((state) => state.workspace)
    const projects = useAppStore((state) => state.projects)

    const handleCreate = () => {
        onCreate({
            name: name.value,
            color,
        })
    }

    return (
        <div>
            <Stack
                p="1rem"
                width="100%"
                direction="vertical"
                spacing="0.75rem">
                <Label
                    fontWeight={600}
                    size="sm">
                    Project name
                </Label>

                <InputControl>
                    <InputPrefix>
                        <ColorButton
                            color={color}
                            onChange={setColor}
                            colors={COLORS}
                        />
                    </InputPrefix>
                    <Input
                        autoFocus
                        placeholder="New Website"
                        value={name.value}
                        onChange={name.onChange}
                    />
                </InputControl>
            </Stack>

            <Footer
                p="0.5rem"
                bg="transparent">
                <Button
                    size="sm"
                    onClick={onBack}>
                    Back
                </Button>
                <Flexer />
                <Button
                    onClick={handleCreate}
                    variant="accent"
                    size="sm"
                    disabled={!name.value}>
                    Create
                </Button>
            </Footer>
        </div>
    )
}
